import React, { Component } from 'react';
import { connect } from 'react-redux';
import { delLap,clearAllLap } from '../../actions';

class Laps extends Component {

  del(id){
      this.props.delLap(id);
  }

  clearBtn(){
    return(
       <div 
       className='del-all-btn' 
       data-toggle="tooltip" 
       title="Clear all" 
       data-placement="right"
       onClick={()=>this.clear()}>
       <i className='fa fa-times-circle'></i>
       </div>
    )
}

    clear(){
        this.props.clearAllLap();
    }

  render() {
      let laps = this.props.laps;
      console.log(this.props);
    return (
      <div className='lap'>
        <ul className='list-group col'>
        {   
            (laps!==null)?laps.map((lap)=>{
                return(
                    <li key={lap.id} className='list-group-item'>
                        <div className='list-item'>
                        <div>{lap.lap}</div>
                        </div>
                        <div className='list-item del-btn' 
                        onClick={()=>this.del(lap.id)}><i className='fa fa-trash-alt'></i></div>
                    </li>
                )
            }):null
            
        }
        </ul>
        {(laps.length!==null)? (laps.length>=2)?this.clearBtn():null : null }
      </div>
    )
  }
}

export default connect(null,{delLap,clearAllLap})(Laps);



// WEBPACK FOOTER //
// ./src/components/stopwatch/Laps.jsx